import Dayjs, { ManipulateType } from 'dayjs';
const DEFAULT_FORMAT = 'YYYY-MM-DD hh:mm:ss';
export const now = () => {
  return Dayjs().format(DEFAULT_FORMAT);
};
export type addProps = {
  num: number;
  type: ManipulateType;
};
export const addNow = (payload: addProps) => {
  const { num, type } = payload;
  const now = Dayjs();
  return now.add(num, type);
  // return add.format(DEFAULT_FORMAT);
};
// type diffProps = {
//   time1: string;
// };
export const diffNow = (time1: string) => {
  // const { time1 } = payload;
   // const time = Dayjs(time1, DEFAULT_FORMAT);
  const now = Dayjs();
  console.log(now.diff(time1, 'second'));
  return now.diff(time1, 'second');
};
